import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import ACTIONS from "../../../../redux/action";
import axios from "../../../../shared/axios/axiosProxy";
import i18n from "../../../../utils/i18n";
import classes from "./companyVatStatus.module.scss";

const VAT_FILTER_VALUES = ["false", "true", "idk"];

const COMPANY_VAT_OPTIONS = [
  { value: "true", label: i18n.t("general.yes"), emoji: "✅" },
  { value: "false", label: i18n.t("general.no"), emoji: "❌" },
  { value: "idk", label: i18n.t("general.idk"), emoji: "🤷‍♂️" },
];

export const isCompanyVatFilterAnswered = (vatFilter) =>
  VAT_FILTER_VALUES.includes(vatFilter);

const resolveVatPaymentForFilter = (vatFilter) =>
  vatFilter === "true" ? "idk" : "";

const Radio = ({ checked }) => (
  <span
    className={`${classes.radio} ${checked ? classes.radioChecked : ""}`}
    aria-hidden="true"
  />
);

const CompanyVatStatus = () => {
  const companyStore = useSelector((state) => state.company_store);
  const dispatch = useDispatch();

  const selectedValue = isCompanyVatFilterAnswered(companyStore.vatFilter)
    ? companyStore.vatFilter
    : "";

  const syncSearchVatFields = useCallback((searchID, vatFilter, vatPayment) => {
    if (!searchID) {
      return;
    }
    axios
      .patch(
        `/api/search/${searchID}`,
        { vatFilter, vatPayment },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
      .catch((error) => {
        console.error(
          "Error saving VAT fields to searchSchema:",
          error.response?.data || error.message,
        );
      });
  }, []);

  const updateVatFilter = useCallback(
    (vatFilter) => {
      const vatPayment = resolveVatPaymentForFilter(vatFilter);

      dispatch(
        ACTIONS.addCompanyInfo({
          id: "vatFilter",
          data: vatFilter,
          stateObject: "company_store",
        }),
      );
      dispatch(
        ACTIONS.addCompanyInfo({
          id: "vatPayment",
          data: vatPayment,
          stateObject: "company_store",
        }),
      );
      syncSearchVatFields(companyStore.searchID, vatFilter, vatPayment);
    },
    [companyStore.searchID, dispatch, syncSearchVatFields],
  );

  return (
    <div className={classes.root}>
      <div className={classes.scrollArea}>
        <div className={classes.content}>
          <div className={classes.mainColumn}>
            <header className={classes.header}>
              <h1 className={classes.title}>{i18n.t("searchflow.vatstatustitle")}</h1>
            </header>

            <div className={classes.rightColumn}>
              <div className={classes.cardsContainer}>
                {COMPANY_VAT_OPTIONS.map((option) => {
                  const isSelected = selectedValue === option.value;

                  return (
                    <button
                      key={option.value}
                      type="button"
                      className={`${classes.card} ${isSelected ? classes.selectedRow : ""}`}
                      onClick={() => updateVatFilter(option.value)}
                      aria-pressed={isSelected}
                    >
                      <span className={classes.cardEmoji} aria-hidden="true">
                        {option.emoji}
                      </span>
                      <div className={classes.cardContent}>
                        <div className={classes.cardTitle}>{option.label}</div>
                      </div>
                      <Radio checked={isSelected} />
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyVatStatus;
